<template>
  <v-dialog v-model="dialog" class="delete-item" :width="$vuetify.breakpoint.smAndUp ? '50%': '98%'" height="50%">
        <template v-slot:activator="{ on }">
            <div v-if="theme" class="roboto-normal-18 clr-black-bb text-right mr-10 my-10 pointer" v-on="on">Удалить раздел</div>
            <div v-if="task" class="roboto-normal-14 clr-black-38 py-2 pl-4 pointer" v-on="on">Удалить</div>
            <div v-if="sub" class="button_add_edit_sub pointer" v-on="on">Удалить</div>
            <div v-if="notice" class="px-2 button_add_edit_notice pointer" v-on="on">Удалить</div>
            <v-btn v-if="images" class="cross-image" small icon v-on="on"><v-icon size="14">close</v-icon></v-btn>
            <div v-if="taskMobile" class="button_change_mobile_task pointer mt-2" v-on="on"><v-icon size="24" class="mr-2">delete_forever</v-icon>Удалить подраздел</div>
            <div v-if="subMobile" class="button_add_edit_sub button_add_edit_sub_mobile mb-1 pointer pointer" v-on="on"><v-icon size="20" class="mr-1">delete_forever</v-icon>Удалить</div>
            <div v-if="themeMobile" class="flex-center-between mt-4 ml-6 mb-4" v-on="on">
                <div class="roboto-normal-16 clr-black-38">Удалить</div>
            </div>
        </template>
        <v-card elevation="10">
            <v-card-title>Вы действительно хотите удалить?</v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteItem">Да</v-btn>
                <v-btn text @click="dialog = false">Нет</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DeleteItem',
    props: ['theme','task', 'sub', 'images', 'notice', 'taskMobile', 'subMobile', 'themeMobile'],
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        deleteItem() {
            this.$emit('deleteItem')
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .button_add_edit_sub_mobile{
        font-size: 14px;
        padding: 6px 12px;
        height: 32px;
        font-weight: 400;
        align-self: flex-start;
        margin-left: 44px;
        box-shadow: none;
    }
    .button_change_mobile_task{
        font-size: 14px;
        padding: 6px 12px;
        height: 32px;
        font-weight: 400;
        box-shadow: none;
        padding-left: 0;
        width: 225px !important;
    }
    .cross-image {
        position: absolute;
        margin-top: -10px;
    }
</style>

<style lang="scss">
.v-dialog .v-card .v-card__title {
    font: 20px Roboto, sans-serif;
}
</style>